import React, { useEffect, useState } from 'react';
import Layout from '../../components/Layout';
import DataTable from 'react-data-table-component';
import { get, del, put, post } from '../../controllers/apiController';

import { toast } from 'react-toastify';

const GoogleAds = () => {
    const [isLoadingAccounts, setIsLoadingAccounts] = useState(false);

    const numberFormatter = new Intl.NumberFormat("tr-TR");

    const [accounts, setAccounts] = useState([]);
    const [selectedAccount, setSelectedAccount] = useState('');
    const [campaigns, setCampaigns] = useState([]);
    const [conversions, setConversions] = useState([]);
    const [keywords, setKeywords] = useState([]);
    const [isLoadingData, setIsLoadingData] = useState(false);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');



    useEffect(() => {
        document.title = "Google Ads | LEVELUP CRM";
        loadAccounts();
        
        // Son 30 günü otomatik set et
        const today = new Date();
        const thirtyDaysAgo = new Date(today);
        thirtyDaysAgo.setDate(today.getDate() - 30);
        
        setEndDate(today.toISOString().split('T')[0]);
        setStartDate(thirtyDaysAgo.toISOString().split('T')[0]);
        
        // Türkçe locale ayarla
        document.documentElement.lang = 'tr';
    }, []);

    const loadAccounts = async () => {
        setIsLoadingAccounts(true);
        try {
            const response = await post('google/alt-hesaplar',{managerCustomerId:7975899496});
            
            // Response direkt array mi yoksa object içinde mi kontrol et
            const accountsData = Array.isArray(response) ? response : response.accounts || response.data || [];
            
            // ID formatını düzenle: customer/3424234 -> 3424234
            const formattedAccounts = accountsData.map(account => ({
                ...account,
                id: account.id && account.id.includes('/') ? account.id.split('/')[1] : account.id
            }));
            setAccounts(formattedAccounts);
        } catch (err) {
            console.error('Hesaplar yüklenirken hata:', err);
            toast.error("Hesaplar yüklenirken bir hata oluştu!");
        } finally {
            setIsLoadingAccounts(false);
        }
    };

    const loadCampaignData = async (customerId, start = '', end = '') => {
        if (!customerId) {
            toast.error("Lütfen bir hesap seçin!");
            return;
        }
        
        setIsLoadingData(true);
        try {
            // API request payload'ı hazırla
            const payload = { customerId };
            if (start && end) {
                // Tarihlerin YYYY-MM-DD formatında olduğundan emin ol
                const formatDate = (dateStr) => {
                    const date = new Date(dateStr);
                    return date.toISOString().split('T')[0]; // YYYY-MM-DD formatı
                };
                
                payload.startDate = formatDate(start);
                payload.endDate = formatDate(end);
                
                console.log('Gönderilen tarihler:', {
                    startDate: payload.startDate,
                    endDate: payload.endDate
                });
            }

            // Kampanyalar ve conversions verilerini al
            const campaignsResponse = await post('google/kampanyalar', payload);
            setCampaigns(campaignsResponse.campaigns || []);
            setConversions(campaignsResponse.conversions || []);

            // Anahtar kelimeler verilerini al
            const keywordsResponse = await post('google/anahtar-kelimeler', payload);
            setKeywords(keywordsResponse || []);

        } catch (err) {
            toast.error("Veriler yüklenirken bir hata oluştu!");
            console.error(err);
        } finally {
            setIsLoadingData(false);
        }
    };

    const handleAccountChange = (e) => {
        const accountId = e.target.value;
        setSelectedAccount(accountId);
        
        // Hesap değiştirildiğinde tabloları temizle
        setCampaigns([]);
        setConversions([]);
        setKeywords([]);
    };

    const handleGetData = () => {
        if (!selectedAccount) {
            toast.error("Lütfen bir hesap seçin!");
            return;
        }
        loadCampaignData(selectedAccount, startDate, endDate);
    };



    const paginationComponentOptions = {
        rowsPerPageText: 'Sayfa başına satır:',
        rangeSeparatorText: 'toplam',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Tümü',
        firstPageText: 'İlk',
        previousPageText: 'Önceki',
        nextPageText: 'Sonraki',
        lastPageText: 'Son',
        noRowsPerPage: false,
    };

    const customStyles = {
        noData: {
            style: {
                padding: '24px',
                textAlign: 'center',
            },
        },
    };

    const campaignColumns = [
       
        {
            name: 'Kampanya Adı',
            selector: row => row.name,
            sortable: true,
            wrap: true,
            cell: row => (
                <div>
                    <span className="ms-2 badge bg-soft-success text-success">{row.name}</span>
                </div>
            )
        },
        {
            name: 'Gösterimler',
            selector: row => row.impressions,
            sortable: true,
            cell: row => numberFormatter.format(row.impressions)
        },
        {
            name: 'Tıklamalar',
            selector: row => row.clicks,
            sortable: true,
            cell: row => numberFormatter.format(row.clicks)
        },
        {
            name: 'CPC',
            selector: row => row.cpc,
            sortable: true,
            cell: row => `₺${row.cpc.toFixed(2)}`
        },
        {
            name: 'Maliyet (TL)',
            selector: row => row.costTL,
            sortable: true,
            cell: row => `₺${numberFormatter.format(row.costTL.toFixed(2))}`
        }
    ];

    const conversionColumns = [
       
        {
            name: 'Kampanya Adı',
            selector: row => row.name,
            sortable: true,
            wrap: true,
            cell: row => (
                <div>
                    <span className="ms-2 badge bg-soft-teal text-teal">{row.name}</span>
                </div>
            )
        },
        {
            name: 'Dönüşümler',
            selector: row => row.conversions,
            sortable: true,
            cell: row => numberFormatter.format(row.conversions)
        }
    ];

    const keywordColumns = [
        {
            name: 'Kampanya Adı',
            selector: row => row.campaignName,
            sortable: true,
            wrap: true,
            width: '200px',
            cell: row => (
                <div>
                    <span className="ms-2 badge bg-soft-warning text-warning">{row.campaignName}</span>
                </div>
            )
        },
        {
            name: 'Reklam Grubu',
            selector: row => row.adGroupName,
            sortable: true,
            wrap: true,
            width: '150px',
            cell: row => (
                <div>
                    <span className="ms-2 badge bg-soft-success text-success">{row.adGroupName}</span>
                </div>
            )
        },
        {
            name: 'Anahtar Kelime',
            selector: row => row.keyword,
            sortable: true,
            wrap: true,
            cell: row => (
                <div>
                    <span className="ms-2 badge bg-soft-primary text-primary">{row.keyword}</span>
                </div>
            )
        },
        {
            name: 'Gösterimler',
            selector: row => row.impressions,
            sortable: true,
            cell: row => numberFormatter.format(row.impressions)
        },
        {
            name: 'Tıklamalar',
            selector: row => row.clicks,
            sortable: true,
            cell: row => numberFormatter.format(row.clicks)
        },
        {
            name: 'Dönüşümler',
            selector: row => row.conversions,
            sortable: true,
            cell: row => numberFormatter.format(row.conversions)
        },
        {
            name: 'Maliyet (TL)',
            selector: row => row.costTL,
            sortable: true,
            cell: row => `₺${numberFormatter.format(row.costTL.toFixed(2))}`
        },
        {
            name: 'CPC',
            selector: row => row.cpc,
            sortable: true,
            cell: row => `₺${row.cpc.toFixed(2)}`
        }
    ];

    return (
        <Layout>
            <main className="nxl-container">
                <div className="nxl-content">
                    <div className="page-header">
                        <div className="page-header-left d-flex align-items-center">
                            <div className="page-header-title">
                                <h5 className="m-b-10">LEVELUP CRM</h5>
                            </div>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><a href="./">Anasayfa</a></li>
                                <li className="breadcrumb-item">Google Ads</li>
                            </ul>
                        </div>
                    </div>
                    <div className="main-content">
                        <div className="row">
                            <div className="col-xxl-12 col-md-12">
                                <div className="card stretch stretch-full">
                                    <div className="card-header">
                                        <h5 className="card-title">Hesaplar</h5>
                                    </div>
                                    <div className="card-body custom-card-action p-4">
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label className="form-label">Google Ads Hesabı</label>
                                                    {isLoadingAccounts ? (
                                                        <div className="d-flex align-items-center">
                                                            <div className="spinner-border spinner-border-sm text-primary me-2" role="status">
                                                                <span className="visually-hidden">Yükleniyor...</span>
                                                            </div>
                                                            <span>Yükleniyor...</span>
                                                        </div>
                                                    ) : (
                                                        <select 
                                                            className="form-select"
                                                            value={selectedAccount}
                                                            onChange={handleAccountChange}
                                                        >
                                                            <option value="">Hesap seçiniz...</option>
                                                            {accounts.map(account => (
                                                                <option key={account.id} value={account.id}>
                                                                    {account.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label className="form-label">Başlangıç Tarihi</label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        value={startDate}
                                                        onChange={(e) => setStartDate(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label className="form-label">Bitiş Tarihi</label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        value={endDate}
                                                        onChange={(e) => setEndDate(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label className="form-label">&nbsp;</label>
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary w-100 d-block"
                                                        onClick={handleGetData}
                                                        disabled={isLoadingData}
                                                    >
                                                        {isLoadingData ? (
                                                            <>
                                                                <div className="spinner-border spinner-border-sm me-2" role="status">
                                                                    <span className="visually-hidden">Yükleniyor...</span>
                                                                </div>
                                                                Yükleniyor...
                                                            </>
                                                        ) : (
                                                            'Getir'
                                                        )}
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label className="form-label">Bilgi</label>
                                                    <div className="form-control-plaintext">
                                                        {accounts.length > 0 ? `${accounts.length} hesap` : 'Hesap yükleniyor...'}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Kampanyalar Tablosu */}
                        {selectedAccount && (
                            <div className="row">
                                <div className="col-xxl-12 col-md-12">
                                    <div className="card stretch stretch-full">
                                        <div className="card-header">
                                            <h5 className="card-title">Kampanyalar</h5>
                                        </div>
                                        <div className="card-body custom-card-action p-2">
                                            {isLoadingData ? (
                                                <div className="w-100 d-flex align-items-center justify-content-center spinner-wrapper py-5">
                                                    <div className="spinner-border text-primary" role="status">
                                                        <span className="visually-hidden">Yükleniyor...</span>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="table-responsive mb-3">
                                                    <DataTable
                                                        columns={campaignColumns}
                                                        data={campaigns}
                                                        className="table table-hover mb-0"
                                                        pagination
                                                        responsive
                                                        noDataComponent="Görüntülenecek kampanya bulunamadı"
                                                        paginationComponentOptions={paginationComponentOptions}
                                                        customStyles={customStyles}
                                                        paginationPerPage={25}
                                                        paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Dönüşümler Tablosu */}
                        {selectedAccount && (
                            <div className="row">
                                <div className="col-xxl-12 col-md-12">
                                    <div className="card stretch stretch-full">
                                        <div className="card-header">
                                            <h5 className="card-title">Dönüşümler</h5>
                                        </div>
                                        <div className="card-body custom-card-action p-2">
                                            {isLoadingData ? (
                                                <div className="w-100 d-flex align-items-center justify-content-center spinner-wrapper py-5">
                                                    <div className="spinner-border text-primary" role="status">
                                                        <span className="visually-hidden">Yükleniyor...</span>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="table-responsive mb-3">
                                                    <DataTable
                                                        columns={conversionColumns}
                                                        data={conversions}
                                                        className="table table-hover mb-0"
                                                        pagination
                                                        responsive
                                                        noDataComponent="Görüntülenecek dönüşüm bulunamadı"
                                                        paginationComponentOptions={paginationComponentOptions}
                                                        customStyles={customStyles}
                                                        paginationPerPage={25}
                                                        paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Anahtar Kelimeler Tablosu */}
                        {selectedAccount && (
                            <div className="row">
                                <div className="col-xxl-12 col-md-12">
                                    <div className="card stretch stretch-full">
                                        <div className="card-header">
                                            <h5 className="card-title">Anahtar Kelimeler</h5>
                                        </div>
                                        <div className="card-body custom-card-action p-2">
                                            {isLoadingData ? (
                                                <div className="w-100 d-flex align-items-center justify-content-center spinner-wrapper py-5">
                                                    <div className="spinner-border text-primary" role="status">
                                                        <span className="visually-hidden">Yükleniyor...</span>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="table-responsive mb-3">
                                                    <DataTable
                                                        columns={keywordColumns}
                                                        data={keywords}
                                                        className="table table-hover mb-0"
                                                        pagination
                                                        responsive
                                                        noDataComponent="Görüntülenecek anahtar kelime bulunamadı"
                                                        paginationComponentOptions={paginationComponentOptions}
                                                        customStyles={customStyles}
                                                        paginationPerPage={25}
                                                        paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </main>
        </Layout>
    );
};

export default GoogleAds;
